import { getLocaleFromPath, getMetierIdFromPath, MARKETING_PATHS } from './localeRoutes';
import { proMarketingHref } from '../components/SEO/marketingCanonicalUrl';
/**
 * Landings métier FR (hub SEO) — maillage header/footer (#1084 v2).
 * Chemins avec slash final (#1164, aligné sitemap / Pretty URL Netlify).
 */

export type MarketingMetierNavLink = {
  path: string;
  labelKey: string;
};

export const FR_MARKETING_METIER_NAV_LINKS: MarketingMetierNavLink[] = [
  { path: '/educateur-canin', labelKey: 'marketingFooter.links.dogTrainer' },
  { path: '/promeneur-canin', labelKey: 'marketingFooter.links.dogWalker' },
  { path: '/pet-sitter', labelKey: 'marketingFooter.links.petSitter' },
  { path: '/pension-canine', labelKey: 'marketingFooter.links.dogBoarding' },
  { path: '/comportementaliste', labelKey: 'marketingFooter.links.behaviorist' },
  { path: '/toiletteur', labelKey: 'marketingFooter.links.groomer' },
  { path: '/logiciel-dog-sitter', labelKey: 'marketingFooter.links.dogSitterSoftware' },
  { path: '/loisir-canin', labelKey: 'marketingFooter.links.loisirCanin' },
  { path: '/ecole-club-canin-logiciel', labelKey: 'marketingFooter.links.ecoleClub' },
];

export const FR_MARKETING_METIER_PATHS = FR_MARKETING_METIER_NAV_LINKS.map((l) => l.path);

/**
 * #1120 v3 : sur une page localisée (/en, /es…), les liens métier doivent pointer
 * vers le slug de la locale (/en/dog-trainer) et non vers la landing FR.
 * Les pages sans équivalent localisé (logiciel-dog-sitter, école-club…) gardent le chemin FR.
 */
/** #1120 v5 : équivalents EN des pages FR sans slug métier propre. */
export const DOG_SITTER_SOFTWARE_ALTERNATES = { fr: '/logiciel-dog-sitter', en: '/en/pet-sitter' } as const;

export function localizedMetierNavPath(frPath: string, currentPathname: string): string {
  const locale = getLocaleFromPath(currentPathname);
  if (!locale || locale === 'fr') return proMarketingHref(frPath);
  if (frPath === DOG_SITTER_SOFTWARE_ALTERNATES.fr && locale === 'en') {
    return proMarketingHref(DOG_SITTER_SOFTWARE_ALTERNATES.en);
  }
  const id = getMetierIdFromPath(frPath);
  if (!id) return proMarketingHref(frPath);
  return proMarketingHref(MARKETING_PATHS[id][locale]);
}

/** #1120 v5 : le logo pointe vers l'accueil de la locale courante (/en/, /es/…). */
export function localizedHomePath(currentPathname: string): string {
  const locale = getLocaleFromPath(currentPathname);
  if (!locale || locale === 'fr') return '/';
  return proMarketingHref(MARKETING_PATHS.home[locale] ?? '/');
}

/** #1120 v6 : ancre d'accueil localisée (/en/#tarifs et non /#tarifs depuis /en). */
export function localizedHomeAnchorPath(anchor: string, currentPathname: string): string {
  const home = localizedHomePath(currentPathname);
  return home === '/' ? `/#${anchor}` : `${home}#${anchor}`;
}
